import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Paper, Button } from '@mui/material';
import { Schedule, Groups, GridOn, Print } from '@mui/icons-material';

// Shared toolbar shown atop every timetable screen so you can hop between
// Setup → Allocations → Grid → Views without going back to the dashboard.
const ITEMS = [
  { label: 'Setup',       path: '/academics/timetable-setup',     Icon: Schedule },
  { label: 'Allocations', path: '/academics/teacher-allocations', Icon: Groups },
  { label: 'Grid',        path: '/academics/timetable-grid',      Icon: GridOn },
  { label: 'Views',       path: '/academics/timetable-print',     Icon: Print },
];

const TimetableNav = ({ className }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <Paper elevation={0} variant="outlined" className={className}
      sx={{ display: 'flex', gap: 0.5, p: 0.5, mb: 2, borderRadius: 2, flexWrap: 'wrap', bgcolor: '#f8f9fa' }}>
      {ITEMS.map(({ label, path, Icon }) => {
        const active = pathname === path;
        return (
          <Button key={path} size="small" startIcon={<Icon />} onClick={() => navigate(path)}
            variant={active ? 'contained' : 'text'}
            sx={{ textTransform: 'none', fontWeight: active ? 700 : 500, color: active ? undefined : 'text.secondary' }}>
            {label}
          </Button>
        );
      })}
    </Paper>
  );
};

export default TimetableNav;
